export function Header() {
  return <header />;
}
